<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">{{ 'shared.editBasicInfoCompany.title' | translate }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <ul class="nav nav-tabs nav-bordered mb-3">
        <li class="nav-item">
          <a 
            class="nav-link active"
            id="data-tab"
            data-bs-toggle="tab"
            data-bs-target="#data"
            type="button"
            role="tab"
            aria-controls="data"
            aria-selected="true"
          >
            <i class="mdi mdi-home-variant d-md-none d-block"></i>
            <span class="d-none d-md-block">{{ 'shared.editBasicInfoCompany.companyDataTab' | translate }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a 
            class="nav-link"
            id="adress-tab"
            data-bs-toggle="tab"
            data-bs-target="#adress"
            type="button"
            role="tab"
            aria-controls="adress"
            aria-selected="false"
          >
            <i class="mdi mdi-account-circle d-md-none d-block"></i>
            <span class="d-none d-md-block">{{ 'shared.editBasicInfoCompany.companyAddressTab' | translate }}</span>
          </a>
        </li>
      </ul>
      <form [formGroup]="formGroup">
        <div class="tab-content" id="tabComponentsContent">
          <div class="tab-pane fade show active" id="data" role="tabpanel" aria-labelledby="data-tab">
            <div class="row">
              <div class="col-lg-6">
                <div class="card">
                  <h6 class="card-header">{{ 'shared.editBasicInfoCompany.dataHeader' | translate }}</h6>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-8 mb-3">
                        <label class="form-label">{{ 'shared.editBasicInfoCompany.nameLabel' | translate }}</label>
                        <input type="text" class="form-control" maxlength="255" formControlName="name" required />
                        <field-error-component [field]="'name'" [label]="('shared.editBasicInfoCompany.nameFieldLabel' | translate)" [formGroup]="formGroup" />
                      </div>
                      <div class="col-lg-4 mb-3">
                        <label class="form-label">{{ 'shared.editBasicInfoCompany.tinLabel' | translate }}</label>
                        <input type="text" class="form-control" [mask]="'00.000.000/0000-00'" formControlName="tin" required />
                        <field-error-component [field]="'tin'" [label]="('shared.editBasicInfoCompany.tinFieldLabel' | translate)" [formGroup]="formGroup" />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6 mb-3">
                        <label class="form-label">{{ 'shared.editBasicInfoCompany.emailLabel' | translate }}</label>
                        <input class="form-control" maxlength="100" formControlName="email" required />
                        <field-error-component [field]="'email'" [label]="('shared.editBasicInfoCompany.emailFieldLabel' | translate)" [formGroup]="formGroup" />
                      </div>
                      <div class="col-lg-6 mb-3">
                        <label class="form-label">{{ 'shared.editBasicInfoCompany.phoneLabel' | translate }}</label>
                        <input class="form-control" maxlength="100" formControlName="phone" [mask]="'0000000000000'"
                          (keypress)="keyPressOnlyNumbers($event)" required />
                        <span class="help-block d-block">
                          <small>{{ 'shared.editBasicInfoCompany.phoneHelp' | translate }}</small>
                        </span>
                        <field-error-component [field]="'phone'" [label]="('shared.editBasicInfoCompany.phoneFieldLabel' | translate)" [formGroup]="formGroup" />
                      </div>
                    </div>

                    @if (isAdmin()) {
                    <div class="row">
                      <div class="col-lg-6 mb-3">
                        <label class="form-label">{{ 'shared.editBasicInfoCompany.companyLanguageLabel' | translate }}</label>
                        <select class="form-select" [value]="currentCompanyLanguage" (change)="onCompanyLanguageChange($any($event.target).value)">
                          @for (locale of locales; track locale) {
                          <option [value]="locale" [selected]="locale === currentCompanyLanguage">
                            {{ localeLabels[locale] }}
                          </option>
                          }
                        </select>
                        <span class="help-block d-block">
                          <small>{{ 'shared.editBasicInfoCompany.companyLanguageHelp' | translate }}</small>
                        </span>
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="card">
                  <h6 class="card-header">{{ 'shared.editBasicInfoCompany.imageHeader' | translate }}</h6>
                  <div class="card-body">
                    <div class="row position-relative">
                      <div class="col-lg-12">
                        <div class="upload-area">
                          @if (loadingSpinner$ | async) {
                          <loading-component class="loading" />
                          } @else {
                          @if (!companyImage) {
                          <div class="placeholder-content" (click)="addImage()">
                            <i class="mdi mdi-cloud-upload-outline upload-icon text-primary"></i>
                            <p class="text-primary">{{ 'shared.editBasicInfoCompany.uploadClickToLoad' | translate }}</p>
                            <p class="text-muted">
                              {{ 'shared.editBasicInfoCompany.uploadFormatHint' | translate }}
                            </p>
                          </div>
                          }
                          }

                          <div class="upload-area__image" [ngStyle]="
                              (loadingSpinner$ | async) ? { filter: 'blur(5px)' } : {}
                            ">
                            @if (companyImage) {
                            <img [src]="companyImage" [alt]="'shared.editBasicInfoCompany.companyImageAlt' | translate" class="preview-img"
                              (click)="$event.stopPropagation()" (error)="onImageLoadError()" />
                            <button class="btn btn-outline-danger" type="button" (click)="removeMedia(); $event.stopPropagation()">
                              <i class="mdi mdi-trash-can-outline"></i>
                            </button>
                            }
                          </div>

                          <input #fileInputFile type="file" accept="image/jpeg, image/png" (change)="onSelectImage($event)" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="tab-pane fade" id="adress" role="tabpanel" aria-labelledby="adress-tab">
            <div class="row">
              <div class="col-lg-8">
                <div class="card">

                  <h6 class="card-header">{{ 'shared.editBasicInfoCompany.addressHeader' | translate }}</h6>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-3 mb-3">
                        <label class="form-label">{{ 'shared.editBasicInfoCompany.zipLabel' | translate }}</label>
                        <input [mask]="'00.000-000'" class="form-control" formControlName="zip" (ngModelChange)="onCep($event)" />
                      </div>
                      <div class="col-lg-2 mb-3">
                        <label class="form-label">{{ 'shared.editBasicInfoCompany.stateLabel' | translate }}</label>
                        <input class="form-control" maxlength="2" formControlName="state" readonly />
                      </div>
                      <div class="col-lg-7 mb-3">
                        <label class="form-label">{{ 'shared.editBasicInfoCompany.addressLabel' | translate }}</label>
                        <input class="form-control" formControlName="address" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 mb-3">
                        <label class="form-label">{{ 'shared.editBasicInfoCompany.cityLabel' | translate }}</label>
                        <input class="form-control" formControlName="city" maxlength="100" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 mb-3">
                        <label class="form-label">{{ 'shared.editBasicInfoCompany.descriptionLabel' | translate }}</label>
                        <textarea class="form-control" formControlName="description" [rows]="2" [cols]="50"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4">
                <div class="card">
                  <h6 class="card-header">{{ 'shared.editBasicInfoCompany.imageHeader' | translate }}</h6>
                  <div class="card-body">
                    <div class="row position-relative">
                      <div class="col-lg-12">
                        <div class="upload-area">
                          @if (loadingSpinner$ | async) {
                          <loading-component class="loading" />
                          } @else {
                          @if (!companyImage) {
                          <div class="placeholder-content" (click)="addImage()">
                            <i class="mdi mdi-cloud-upload-outline upload-icon text-primary"></i>
                            <p class="text-primary">{{ 'shared.editBasicInfoCompany.uploadClickToLoad' | translate }}</p>
                            <p class="text-muted">
                              {{ 'shared.editBasicInfoCompany.uploadFormatHint' | translate }}
                            </p>
                          </div>
                          }
                          }

                          <div class="upload-area__image" [ngStyle]="
                              (loadingSpinner$ | async) ? { filter: 'blur(5px)' } : {}
                            ">
                            @if (companyImage) {
                            <img [src]="companyImage" [alt]="'shared.editBasicInfoCompany.companyImageAlt' | translate" class="preview-img"
                              (click)="$event.stopPropagation()" (error)="onImageLoadError()" />
                            <button class="btn btn-outline-danger" type="button" (click)="removeMedia(); $event.stopPropagation()">
                              <i class="mdi mdi-trash-can-outline"></i>
                            </button>
                            }
                          </div>

                          <input #fileInputFile type="file" accept="image/jpeg, image/png" (change)="onSelectImage($event)" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()" [disabled]="loading">
        {{ 'shared.editBasicInfoCompany.cancelButton' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="save()" [disabled]="loading">
        {{ 'shared.editBasicInfoCompany.saveButton' | translate }}
        @if (loading) {
        <mat-spinner [diameter]="15" [color]="'accent'" mode="indeterminate" />
        }
      </button>
    </div>
  </div>
</div>